export class OrganizationTypes {
    static GOVERNMENT_AGENCY_STRING = 'Authority';
    static COMPANY_STRING = 'Company';
}



// WEBPACK FOOTER //
// ./src/app/shared/constants/organization-types.ts